import React from 'react';

import { useDispatch } from '@lumapps/redux/react';
import { captureFocusedTrigger } from '@lumapps/utils/focus/captureFocusedTrigger';

import { actions } from '../ducks/slice';

/** Hook to get the article dialog open state and toggle it. */
export const useArticleDialog = () => {
    const dispatch = useDispatch();
    const dialogTriggerRef = React.useRef<HTMLButtonElement | null>(null);
    const [isArticleDialogOpen, setIsArticleDialogOpen] = React.useState(false);

    const openArticleDialog = React.useCallback(() => {
        // Capture the element that opened the dialog so focus can be restored to it on close.
        captureFocusedTrigger(dialogTriggerRef);
        setIsArticleDialogOpen(true);
    }, []);

    const closeArticleDialog = React.useCallback(() => {
        setIsArticleDialogOpen(false);
        dispatch(actions.clearEditedArticle());
    }, [dispatch]);

    /** Closing the dialog and clearing edited article on component unmount */
    React.useEffect(
        () => () => {
            if (isArticleDialogOpen) {
                dispatch(actions.clearEditedArticle());
            }
        },
        [dispatch, isArticleDialogOpen],
    );

    return {
        isOpen: isArticleDialogOpen,
        openArticleDialog,
        closeArticleDialog,
        dialogTriggerRef,
    };
};
